module.exports = ".bootstrap.ng2-tag-input {\n  border: none !important; }\n\n.bootstrap.ng2-tag-input:focus {\n  border: none !important; }\n\n.bootstrap tag {\n  background: none !important;\n  border: solid 1px #E75200 !important; }\n\n.tag__text {\n  color: #E75200 !important;\n  line-height: 28px !important;\n  font-weight: normal; }\n\n.bootstrap path, .bootstrap path {\n  fill: #E75200 !important; }\n\n.bootstrap svg, .bootstrap svg {\n  position: relative !important;\n  top: -3px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/tags-custom/tags-custom.component.scss
// module id = ./src/app/component/tags-custom/tags-custom.component.scss
// module chunks = main